module.exports = __webpack_public_path__ + "static/media/banner_volvo_eicher_v3.e7473077.png";